import CustomerLoader from "../../../../../components/CustomLoader";
import {
  doTransformData,
  fallIncidentPlaceCols,
  handlePointClicked,
  transformDataForBarChart,
} from "../formUtils";
import { LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal, { DefaultContainer } from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { incidentLists } from "../../dummyData/colums";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";

const PlaceOfIncident = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);
  const [barData, setBarData] = useState<any>([]);
  const [placeOfIncident, setPlaceOfIncident] = useState("");
  const [showPlaceModal, setShowPlaceModal] = useState(false);
  const [placeDetails, setPlaceDetails] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getFallIncidentPlace, getPlaceOfIncidentDetails } = useAnalytics({
    facility: fallFacility?.value || "",
    startDate: moment(startDate).format("yyyy-MM-DD"),
    endDate: moment(endDate).format("yyyy-MM-DD"),
    place: placeOfIncident,
  });

  const { data: placeOfIncidentData, isFetching: isFetchingPlaceOfIncident } =
    getFallIncidentPlace;

  const { data: placeOfIncidentDetailsData, isFetching: isFetchingDetails } =
    getPlaceOfIncidentDetails;

  useEffect(() => {
    if (placeOfIncidentData !== undefined) {
      const tempData = placeOfIncidentData?.data.data;
      const transformedTableData = doTransformData(
        tempData,
        "placeOfIncident",
        "place",
        "Total"
      );
      const transformedBarData = transformDataForBarChart(
        transformedTableData,
        "Place of Incident"
      );
      setTableData(transformedTableData);
      shareTableData(transformedTableData);
      setBarData(transformedBarData);
    }
  }, [placeOfIncidentData]);

  useEffect(() => {
    if (placeOfIncidentDetailsData) {
      const tempDetails = placeOfIncidentDetailsData.data.data.map((item: any) => ({
        ...item,
      }));
      setPlaceDetails(tempDetails);
    }
  }, [placeOfIncidentDetailsData]);

  const title = "Place of Incident by Count/Percentage";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    setShowPlaceModal(true);
    setPlaceOfIncident(label);
  };

  useEffect(() => {
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    let cellPercentageProps = {
      cells: {
        data: CenteredWholeNumCell,
        append: "%",
        headerCell: HeaderCenteredCell,
      },
    };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="place" title="Place" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]);

  return (
    <LayerContent>
      {isFetchingPlaceOfIncident ? (
        <CustomerLoader />
      ) : (
        <DefaultContainer
          title={title}
          grid={grid}
          handleBarClicked={(chart: any) => handleBarClicked(chart)}
          barData={barData}
          barType="vertical"
        />
      )}
      {showPlaceModal ? (
        <SectionModal
          open={showPlaceModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowPlaceModal(false)}
          resetFn={() => {
            setPlaceOfIncident("");
            setPlaceDetails(undefined);
          }}
          isLoading={isFetchingDetails || isFetchingSelectedIncident}
          tableData={placeDetails}
          title={`${title} - ${placeOfIncident}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: placeDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${title} - ${placeOfIncident}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              placeDetails,
              incidentLists(),
              `${fallFacility?.label} - ${title}-${placeOfIncident}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default PlaceOfIncident;
